import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./assets/css/index.css";
import global_ from "./Global.vue";
import Loading from "./views/officialAccount/loading.vue";
Vue.component("loading", Loading);

Vue.prototype.GLOBAL = global_;
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
